import React from "react";
import Table from "react-bootstrap/Table";
import { Form } from 'react-bootstrap';
import { FaList, FaPencilAlt, FaTrash } from 'react-icons/fa';

import ApiUiController from "../../controller/ApiUiController";

class DuplicateTableUI extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fields: props.fields, listPopup: false };
  }

  UNSAFE_componentWillReceiveProps(props) {
    const len =
      props.fields.length > this.state.fields.length
        ? props.fields.length
        : this.state.fields.length;
    for (let i = 0; i < len; i++) {
      if (
        i === props.fields.length ||
        i === this.state.fields.length ||
        props.fields[i] !== this.state.fields[i]
      ) {
        this.setState({
          ...this.state,
          fields: props.fields,
          listPopup: false,
        });
        break;
      }
    }
  }

  Display = (modelFields, fields, model) => {
    return [ ...fields.filter(field => modelFields[field]).map((field, i) => 
                  <div key={`data_${model.id}_${i}`}>{modelFields[field].label_name} : {model[field]}</div>),
      <div key={`action_${model.id}`}>
        <FaList className="actionbtnp" onClick={() => this.props.onPreview(model)} />
        <FaPencilAlt className="actionbtne" onClick={() => this.props.onAddEdit(model)} />
        <FaTrash className="actionbtnd" onClick={() => this.props.onDelete(model)} />
      </div>
    ];
  }

  Displays = (modelFields, fields, models, i) => {
    if(i < models.length) {
      return this.Display(modelFields, fields, models[i]);// fields.filter(field => modelFields[field]).map(field => <div>{modelFields[field].label_name} : {models[i][field]}</div>);
    } else {
      return null;
    }
  }

  showListPopup = () =>
    this.setState({ ...this.state, listPopup: !this.state.listPopup });

  onFieldSelection = (fields) => {
    this.setState({ ...this.state, fields: fields, listPopup: false });
    this.props.onFieldSelection(fields);
  };

  render() {
    const data = this.props.data;
    const fields = this.state.fields;
    let list;
    if (!data || data.length === 0) {
      list = (
        <tr>
          <td colSpan={fields.length + 2}>No Records Found</td>
        </tr>
      );
    } else {
      list = data.map((lead, _i) => 
        <tr key={`tr_${_i}`}>
          <td>{lead.id}</td>
          <td>{this.Display(this.props.model.fields, fields, lead)}</td>
          {[...Array(this.props.duplicateCount).keys()].map(i =>
            <td key={`row_${_i}_${i}`}>
              { this.Displays(this.props.model.fields, fields, lead.duplicate, i) ? 
                <Form.Check type="checkbox">
                  <Form.Check.Input type="checkbox" onChange={evt => evt.target.checked 
                    ? this.props.onSelect(lead.id) : this.props.onRemove(lead.id)} />
                    <Form.Check.Label>{ this.Displays(this.props.model.fields, fields, lead.duplicate, i) }</Form.Check.Label>
                </Form.Check>
                : null
              }
            </td>
          )}
        </tr>
      );
    }

    return (
      <div className={`padding-r col-md-${this.props.isFilterOpen ? 9 : 12}`}>
        <ApiUiController inApiCall={this.props.inApiCall}>
          <Table striped bordered hover className="table-cursor">
          <thead>
            <tr>
              <th>Id</th>
              <th>Main Data</th>
              {[...Array(this.props.duplicateCount).keys()].map(i => 
                <th key={`col_${i}`}>
                  <Form.Check type="checkbox">
                    <Form.Check.Input type="checkbox" onChange={evt => evt.target.checked 
                      ? this.props.onSelectAll(i) : this.props.onRemoveAll(i)} />
                      <Form.Check.Label>Duplicate { i + 1 }</Form.Check.Label>
                  </Form.Check>
                </th>
              ) }
            </tr>
          </thead>
            <tbody className="listlead">{list}</tbody>
          </Table>
        </ApiUiController>
      </div>
    );
  }
}
export default DuplicateTableUI;
